/**
 * UI上からアップロードされたファイル一覧のIDを整形して返す
 */
export const formatUploadedFiles = (files) => (files === null || files === void 0 ? void 0 : files.map((file) => ({
    // 既存のファイルID
    file_id: file.id === null ? undefined : file.id,
    // 新たにアップロードされたファイルID
    new_file_id: file.new_file_id === null ? undefined : file.new_file_id,
}))) || [];
